
import axios from 'axios';

import Debug from 'debug';
import config from '../config/index';

const debug = Debug('analytics-ui');

const GET = 'get';
const POST = 'post';
const DELETE = 'delete';
const PUT = 'put';


export function apiClient(apiLib) {
    const defaultOptions = {
        method: GET,
        url: '',
        params: {},
        data: null,
    };

    return (useCustom) => (apiEndpoint) => ({
        get(url, params = {}) {
            const urlEndpoint = useCustom ? apiEndpoint : apiEndpoint();
            const absoluteUrl = urlEndpoint + url;
            const jwtToken = false;
            debug('GET request to url: ', absoluteUrl);

            return apiLib({
                ...defaultOptions,
                method: GET,
                url: absoluteUrl,
                params,
                headers: {
                    // any custom headers go here
                    Authorization: jwtToken ? `Bearer ${jwtToken}` : '',
                },
            });
        },
        delete(url, params = {}) {
            const urlEndpoint = useCustom ? apiEndpoint : apiEndpoint();
            const absoluteUrl = urlEndpoint + url;
            const jwtToken = false;
            debug('DELETE request to url: ', absoluteUrl);

            return apiLib({
                ...defaultOptions,
                method: DELETE,
                url: absoluteUrl,
                params,
                headers: {
                    // any custom headers go here
                    Authorization: jwtToken ? `Bearer ${jwtToken}` : '',
                },
                xsrfCookieName: 'add csrf cookie name here',
                xsrfHeaderName: 'add csrf header name',
            });
        },
        put(url, params = {}, data = {}) {
            const urlEndpoint = useCustom ? apiEndpoint : apiEndpoint();
            const absoluteUrl = urlEndpoint + url;
            const jwtToken = false;

            return apiLib({
                ...defaultOptions,
                method: PUT,
                url: absoluteUrl,
                params,
                data,
                headers: {
                    // any custom headers go here
                    Authorization: jwtToken ? `Bearer ${jwtToken}` : '',
                },
                xsrfCookieName: 'add csrf cookie name here',
                xsrfHeaderName: 'add csrf header name',
            });
        },
        post(url, params = {}, data = {}) {
            const urlEndpoint = useCustom ? apiEndpoint : apiEndpoint();
            const absoluteUrl = urlEndpoint + url;
            debug('POST request to url:', absoluteUrl);
            const jwtToken = false;

            return apiLib({
                ...defaultOptions,
                method: POST,
                url: absoluteUrl,
                params,
                data,
                headers: {
                    // any custom headers go here
                    Authorization: jwtToken ? `Bearer ${jwtToken}` : '',
                },
                xsrfCookieName: 'add csrf cookie name here',
                xsrfHeaderName: 'add csrf header name',
            });
        },
        multiPart(url, params = {}, data = {}) {
            const urlEndpoint = useCustom ? apiEndpoint : apiEndpoint();
            const absoluteUrl = urlEndpoint + url;
            debug('Attempting multi-part request to url:', absoluteUrl);
            const jwtToken = false;

            return apiLib({
                ...defaultOptions,
                method: POST,
                url: absoluteUrl,
                params,
                data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: jwtToken ? `Bearer ${jwtToken}` : '',
                },
                xsrfCookieName: 'add csrf cookie name here',
                xsrfHeaderName: 'add csrf header name',
            });
        },
        blob(url, params = {}) {
            const urlEndpoint = useCustom ? apiEndpoint : apiEndpoint();
            const absoluteUrl = urlEndpoint + url;
            debug('Attempting blob download of file:', absoluteUrl);
            const jwtToken = false;

            return apiLib({
                ...defaultOptions,
                method: GET,
                url: absoluteUrl,
                params,
                headers: {
                    // any custom headers go here
                    Authorization: jwtToken ? `Bearer ${jwtToken}` : '',
                },
                responseType: 'blob', // this is what makes it go in download mode
            });
        },
    });
}

export const customApiCaller = apiClient(axios)(true);

const computeApiEndpoint = () => {
    return config.API_BASE_URL;
};

const api = apiClient(axios)(false)(computeApiEndpoint);

export default api;